<template>
    <container>
        <row>
            <template v-if="animateUpdate">
                <transition-group name="sort-transition">
                    <column :md="12" :lg="8" v-for="property in properties" :key="`properties-standard-list-${property.id}`" class="pb-4">
                        <property-common-card class="h-100" :disableNoRates="disableNoRates" :property="property" :checkIn="checkIn" :checkOut="checkOut" :quotePerNight="quotePerNight" :useBedsCount="useBedsCount" />
                    </column>
                </transition-group>
            </template>
            <template v-else>
                <column :md="12" :lg="8" v-for="property in properties" :key="`properties-standard-list-${property.id}`" class="pb-4">
                    <property-common-card class="h-100" :disableNoRates="disableNoRates" :property="property" :checkIn="checkIn" :checkOut="checkOut" :quotePerNight="quotePerNight" :useBedsCount="useBedsCount" />
                </column>
            </template>

            <column :md="12" :lg="8" class="pb-4">
                <personal-approach-card :checkIn="checkIn" :checkOut="checkOut" :adults="adults" :children="children" class="h-100" :inquireType="inquireType"/>
            </column>
        </row>
    </container>
</template>

<script type="text/javascript">
    import PropertyCommonCard from '@/components/Content/Public/Properties/Cards/Common.vue';
    import PersonalApproachCard from '@/components/Content/Public/Properties/Cards/PersonalApproach.vue';

    import Collection from '@/classes/Collection.js';
    import DateObject from '@/classes/DateObject.js';
    import CommonComponents from '@/components/Common.vue';

    export default {
        components: {
            PropertyCommonCard,
            PersonalApproachCard,
            ...CommonComponents,
        },
        
        props: {
            properties: {
                type: Collection,
                required: true,
            },

            checkIn: {
                type: DateObject,
            },

            checkOut: {
                type: DateObject,
            },

            adults: {
                type: Number,
            },

            children: {
                type: Number,
            },

            quotePerNight: {
                type: Boolean,
                default: false,
            },

            useBedsCount: {
                type: Boolean,
                default: false,
            },

            inquireType: {
                type: String,
            },

            disableNoRates: {
                type: Boolean,
                default: false,
            },

            animateUpdate: {
                type: Boolean,
                default: false,
            },
        },
    };

</script>
